import {
  findIconDefinition,
  parse,
  type IconDefinition,
} from '@fortawesome/fontawesome-svg-core';

export const resolveTaskTypeIcon = (
  iconId: string | null
): IconDefinition | null => {
  const normalizedIconId = iconId?.trim();
  if (!normalizedIconId) return null;

  const iconLookup = parse.icon(normalizedIconId);
  if (!iconLookup) return null;

  return findIconDefinition(iconLookup) ?? null;
};
